import ProductDetail from "../features/product/ProductDetail";

export default function AdminProductPage() {
  return (
    <div>
      <ProductDetail />
    </div>
  );
}
